"use client";

import Image from "next/image";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./ProcessSliderSection.scss";

const ProcessSliderSection = ({
  title = "",
  description = "",
  items = [],
  sectionClass = "",
  background = "bg-white",
}) => {
  if (!items.length) return null;

  const titleParts = title.split('"');

  // Duplicate items sufficiently so the slider track always covers screen width seamless loop resets
  const getLoopItems = () => {
    if (items.length === 0) return [];
    let duplicated = [...items];
    while (duplicated.length < 12) {
      duplicated = [...duplicated, ...items];
    }
    return duplicated;
  };

  const sliderItems = getLoopItems();

  const renderTitle = () => {
    if (titleParts.length >= 3) {
      return (
        <>
          {titleParts[0]}
          <span className="highlight-font">{titleParts[1]}</span>
          {titleParts.slice(2).join('"')}
        </>
      );
    }

    return <span dangerouslySetInnerHTML={{ __html: title }} />;
  };

  return (
    <section
      className={`process-slider-section process-slider-section--${background} ${sectionClass}`}
    >
      <Container>
        <div className="process-slider-header">
          <h2 className="process-slider-title">{renderTitle()}</h2>

          {description && (
            <p
              className="process-slider-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>

        <div className="process-slider-wrapper">
          <Swiper
            modules={[Autoplay]}
            loop={true}
            loopAdditionalSlides={4}
            speed={6000}
            slidesPerView="auto"
            spaceBetween={40}
            allowTouchMove={true}
            grabCursor={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
          >
            {sliderItems.map((item, index) => {
              const media = item.icon || item.image;

              return (
                <SwiperSlide key={`${item.id || "item"}-${index}`}>
                  <article className="process-slider-card">
                    {media && (
                      <div
                        className={`process-slider-media ${
                          item.image
                            ? "process-slider-media--image"
                            : "process-slider-media--icon"
                        }`}
                      >
                        <Image
                          src={media}
                          alt={item.alt || item.title || ""}
                          fill
                          sizes="(max-width: 576px) 48px, 55px"
                        />
                      </div>
                    )}

                    <div
                      className={`process-slider-card-content ${
                        item.subtitle ? "has-subtitle" : "no-subtitle"
                      }`}
                    >
                      {item.title && <h4>{item.title}</h4>}

                      {item.subtitle && (
                        <h6 className="process-slider-card-subtitle">
                          {item.subtitle}
                        </h6>
                      )}

                      {item.description && (
                        <p
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      )}
                    </div>
                  </article>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default ProcessSliderSection;
